/* @flow */

import EventEmitter from 'events';
import { configureStore, sagaMiddleware } from './store/configureStore';
import * as idUtils from './utils/id';
import { emitEvent, openModal, closeModal } from './actions';
// import ModalRenderer from './ui/renderers/modal';

import { notificationSaga } from './middleware/notifications/sagas/index';

const store = configureStore();
sagaMiddleware.run(notificationSaga);

//this renders the container div and not the actual modal.
//for showing/closing the modal we use the actions openModal and closeModal

export default class Core extends EventEmitter {
    store: Object;
    validEvents: Array<string>;
    id: number;

    constructor(clientID: string, options: Object = {}) {
        super();
        // const modalID = 'inplayer-modal';
        // const modalRenderer = new ModalRenderer(store);
        // modalRenderer.render(modalID, { contentLabel: 'Inplayer Modal' });

        if (typeof clientID !== 'string') {
            throw new Error(
                'A `uuid` string must be provided as first argument.'
            );
        }
        if (typeof options !== 'object') {
            throw new Error(
                'When provided, the third argument must be an `options` object.'
            );
        }

        this.store = store;

        this.validEvents = [
            'authenticated',
            'access.revoked',
            'access.granted',
            'subscribe.failed',
            'subscribe.success',
            'payment.card.success',
            'payment.card.failed',
            'logout',
            'error',
            'authorization_error',
        ];

        this.id = idUtils.incremental();

        this.on('newListener', type => {
            if (this.validEvents.indexOf(type) === -1) {
                this.store.dispatch(
                    emitEvent('unrecoverable_error', `Invalid event - ${type}`)
                );
            }
        });
    }

    show = (assetID: number | string) => {
        this.store.dispatch(openModal(assetID));
    };

    hide = () => {
        this.store.dispatch(closeModal());
    };
}



// WEBPACK FOOTER //
// ./src/core.js